export interface LegalNoticeSection {
  titleKey: string;
  descriptionKey: string;
}

export const legalNoticeData: LegalNoticeSection[] = [
  // Mentions légales classiques
  {
    titleKey: "editor.title",
    descriptionKey: "editor.description",
  },
  {
    titleKey: "hosting.title",
    descriptionKey: "hosting.description",
  },
  {
    titleKey: "intellectualProperty.title",
    descriptionKey: "intellectualProperty.description",
  },
  {
    titleKey: "personalData.title",
    descriptionKey: "personalData.description",
  },
  {
    titleKey: "cookies.title",
    descriptionKey: "cookies.description",
  },
  {
    titleKey: "liability.title",
    descriptionKey: "liability.description",
  },
  {
    titleKey: "applicableLaw.title",
    descriptionKey: "applicableLaw.description",
  },
  // Conditions commerciales
  {
    titleKey: "projectStart.title",
    descriptionKey: "projectStart.description",
  },
  {
    titleKey: "payment.title",
    descriptionKey: "payment.description",
  },
  {
    titleKey: "deliveryDeadlines.title",
    descriptionKey: "deliveryDeadlines.description",
  },
  {
    titleKey: "maintenance.title",
    descriptionKey: "maintenance.description",
  },
  {
    titleKey: "modificationsAndAdditions.title",
    descriptionKey: "modificationsAndAdditions.description",
  },
  {
    titleKey: "googleMyBusiness.title",
    descriptionKey: "googleMyBusiness.description",
  },
  {
    titleKey: "intellectualPropertyTransfer.title",
    descriptionKey: "intellectualPropertyTransfer.description",
  },
  {
    titleKey: "confidentiality.title",
    descriptionKey: "confidentiality.description",
  },
  {
    titleKey: "termination.title",
    descriptionKey: "termination.description",
  },
  {
    titleKey: "contact.title",
    descriptionKey: "contact.description",
  },
];
